import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TechnicalInformationComponent} from './technical-information.component';
import {ConfigModule, I18nModule} from '@spartacus/core';

import {MediaModule} from '@spartacus/storefront';
import {ClassificationsTemplateModule} from '../classifications-template/classifications-template.module';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductTechnicalInformationComponent: {
          component: TechnicalInformationComponent,
        },
      },
    }),
    I18nModule,
    MediaModule,
    ClassificationsTemplateModule,
    TechnicalInformationComponent,
  ],
  exports: [TechnicalInformationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TechnicalInformationModule {}
